import { AddIcon, CloseIcon, MinusIcon } from "@chakra-ui/icons";
import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Box, Button, Icon, IconButton, Input, InputGroup, InputRightElement, Stack, Text } from "@chakra-ui/react";
import { MdOutlinePlayCircle } from "react-icons/md";

const FileSelector = (
  { videoUrl,
    setVideoUrl,
    handleLoadMovie,
    isFileSelectorOpen = false,
    setIsFileSelectorOpen
  }:
    {
      videoUrl: string | undefined,
      setVideoUrl: React.Dispatch<React.SetStateAction<string | undefined>>,
      handleLoadMovie: () => void,
      isFileSelectorOpen: boolean,
      setIsFileSelectorOpen: React.Dispatch<React.SetStateAction<boolean>>,
    }) => {

  return (
    <Accordion allowToggle index={isFileSelectorOpen ? 0 : -1} pb={2}>
      <AccordionItem>
        {({ isExpanded }) => (
          <>
            <h2>
              <AccordionButton onClick={() => setIsFileSelectorOpen(!isFileSelectorOpen)}>
                <Box as='span' flex='1' textAlign='left' color='bmp.primary'>
                  <Text as={'b'} color='bmp.primary'>Movie File Information</Text>
                </Box>
                {isExpanded ? (
                  <MinusIcon fontSize='12px' color='bmp.primary' />
                ) : (
                  <AddIcon fontSize='12px' color='bmp.primary' />
                )}
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <Stack dir="column">
                <Text color='bmp.primary'>Movie File URL</Text>
                <InputGroup>
                  <Input
                    focusBorderColor='bmp.primary'
                    placeholder='URL'
                    value={videoUrl ?? ""}
                    onChange={(e) => setVideoUrl(e.target.value)}
                  />
                  <InputRightElement width='4.5rem'>
                    <IconButton
                      size={'sm'}
                      bg="bmp.primary"
                      _hover={{ bg: "bmp.primary-hover" }}
                      color="white"
                      aria-label='Clear'
                      icon={<CloseIcon />}
                      onClick={() => setVideoUrl(undefined)}
                    />
                  </InputRightElement>
                </InputGroup>
                <Button
                  rightIcon={<Icon boxSize={5} as={MdOutlinePlayCircle} />}
                  bg="bmp.primary"
                  _hover={{ bg: "bmp.primary-hover" }}
                  color="white"
                  variant='solid'
                  onClick={handleLoadMovie}>
                  Load Movie
                </Button>
              </Stack>
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
}

export default FileSelector;